export enum SampleStatus {
  'New' = 'New',
  'At Lab' = 'At Lab',
  'Analyzed' = 'Analyzed',
  'Collected' = 'Collected',
  'Completed' = 'Completed',
  'Invalidated' = 'Invalidated'
}
